import { j as u } from "../../../jsx-runtime-BwWtxLpl.js";
import E from "classnames";
import o from "prop-types";
import { useContext as d, useRef as M, useEffect as x } from "react";
import { IconoirXmark as V } from "@ey-xd/motif-icon";
import "../form-field/form-field.js";
import { FormFieldContext as k } from "../form-field/form-field.context.js";
import { MotifIcon as q } from "../../icon/icon.js";
import { IconContext as O } from "../../icon/icon.context.js";
import "../../button/button.js";
import "../../dropdown-portal/dropdown-portal.js";
import { MotifIconButton as P } from "../../button/icon-button/icon-button.js";
let g;
g = 0;
const S = {
  clear: V
}, z = ({
  className: h = "",
  disabled: e = !1,
  icons: a = {},
  id: c = "",
  required: r = !1,
  onBlur: C = () => null,
  onChange: F = () => null,
  onFocus: I = () => null,
  placeholder: s = null,
  type: j = "text",
  value: B = "",
  hideClearButton: b = !1,
  clearButtonTitle: v = "Clear",
  ...y
}) => {
  const t = d(k), { input: f } = d(O), i = B.toString(), m = M(null);
  let l;
  f ? l = {
    ...f,
    ...a
  } : l = {
    ...S,
    ...a
  }, x(() => {
    t.setRequired(r), t.setDisabled(e), t.setFormElementType("textInput"), c ? t.setId(c) : t.setId(`motif-input-${g++}`);
  }, [e]), x(() => {
    t.setValue(i), t.setHasContent(i.length > 0 || s && s.length > 0);
  }, [s, i]);
  const N = (n) => {
    t.toggleFocus(n), C(n);
  }, p = (n) => {
    t.setValue(n.target.value), F(n);
  }, T = (n) => {
    t.toggleFocus(n), I(n);
  }, R = () => {
    p({ target: { value: "" } }), m.current.focus();
  }, w = E({
    "motif-input": !0,
    "motif-input-invalid": t.invalid,
    "motif-input-has-value": t.hasContent,
    "motif-input-disabled": e,
    "motif-input-required": r,
    "motif-input-focused": t.isFocused,
    "motif-input-with-icon-prefix": t.iconPrefix,
    "motif-input-with-icon-suffix": t.iconSuffix,
    [h]: !0
  });
  return /* @__PURE__ */ u.jsxs("div", { className: "motif-input-component", "data-motif-input": !0, children: [
    /* @__PURE__ */ u.jsx(
      "input",
      {
        ...y,
        id: t.id,
        ref: m,
        disabled: e,
        className: w,
        type: j,
        onFocus: T,
        onBlur: N,
        onChange: p,
        value: i,
        required: r,
        placeholder: s
      }
    ),
    i.length > 0 && !b && /* @__PURE__ */ u.jsx(
      P,
      {
        onClick: R,
        disabled: e,
        title: v,
        className: "motif-input-clear-button",
        children: /* @__PURE__ */ u.jsx(q, { size: "20px", iconFunction: l.clear })
      }
    )
  ] });
};
z.propTypes = {
  className: o.string,
  disabled: o.bool,
  required: o.bool,
  icons: o.shape({
    clear: o.node
  }),
  id: o.string,
  onBlur: o.func,
  onChange: o.func,
  onFocus: o.func,
  placeholder: o.string,
  hideClearButton: o.bool,
  clearButtonTitle: o.string,
  type: o.oneOf(["date", "email", "number", "text", "password", "tel"]),
  value: o.oneOfType([o.string, o.number])
};
export {
  z as MotifInput
};
